import { container, singleton } from "tsyringe";
import ContributorRequestResource from "common/resources/Project/Config/Contributor/ContributorRequestResource";
import ContributorResponseResource from "common/resources/Project/Config/Contributor/ContributorResponseResource";
import toValidationError from "utils/toValidationError";
import ProjectLeaderApi from "api/clapaction/projects/[id]/config/team/[projectTeamId]/ProjectLeaderApi";

@singleton()
export default class ProjectLeaderService {
	private api: ProjectLeaderApi = container.resolve(ProjectLeaderApi);

	/**
	 * @description Create project leader
	 */
	public async create(projectId: string, projectTeamId: string, request: ContributorRequestResource, avatar?: File): Promise<ContributorResponseResource> {
		return this.api.create(projectId, projectTeamId, request, avatar).catch(toValidationError);
	}

	/**
	 * @description Update project leader
	 */
	public async update(projectId: string, projectTeamId: string, contributorId: string, request: ContributorRequestResource, avatar?: File): Promise<ContributorResponseResource> {
		return this.api.update(projectId, projectTeamId, contributorId, request, avatar).catch(toValidationError);
	}
}
